/**
 * @file: delay.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

export function delayed(callback: () => void, ms?: number) {
  const timer = setTimeout(() => {
    clearTimeout(timer);
    callback();
  }, ms);
  return () => {
    clearTimeout(timer);
  };
}

export function periodically(callback: () => void, ms?: number) {
  const timer = setInterval(() => {
    callback();
  }, ms);
  return () => {
    clearTimeout(timer);
  };
}
